import { defineProperty as _defineProperty } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { ProductResultBertTaxonomy, ProductResultTaxonomy, CustomerWorkResultTaxonomy, HelpResultTaxonomy, CategoriesResultTaxonomy, DesignResultTaxonomy, InspirationResultTaxonomy } from '../../taxonomy/Taxonomies.js';
import { HELP_CENTER_APPLICATION_NAME } from '../../../util/constants.js';

var helpCenterSearchBarDisplayConfiguration = {
  maxResults: 15,
  maxResultsPerTaxonomy: _defineProperty({
    "default": 3
  }, CustomerWorkResultTaxonomy.id, 2),
  taxonomyOrder: [CustomerWorkResultTaxonomy.id, HelpResultTaxonomy.id, CategoriesResultTaxonomy.id, ProductResultTaxonomy.id, DesignResultTaxonomy.id, InspirationResultTaxonomy.id],
  resultTypeOrderingPerTaxonomy: _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, HelpResultTaxonomy.id, ['myaccount', 'helpcenter', 'staticpages']), CategoriesResultTaxonomy.id, ['categories']), ProductResultTaxonomy.id, ['products']), CustomerWorkResultTaxonomy.id, ['work_entity_service', 'order_history']),
  taxonomyConfiguration: _defineProperty({}, CustomerWorkResultTaxonomy.id, [{
    resultTypeId: 'work_entity_service',
    maxResultsByResultType: 1
  }, {
    resultTypeId: 'order_history',
    maxResultsByResultType: 1
  }]),
  taxonomyFallback: _defineProperty({}, ProductResultTaxonomy.id, ProductResultBertTaxonomy.id)
};
var searchBarDisplayConfiguration = {
  maxResults: 8,
  maxResultsPerTaxonomy: _defineProperty(_defineProperty({}, ProductResultTaxonomy.id, 8), CategoriesResultTaxonomy.id, 4),
  taxonomyOrder: [CategoriesResultTaxonomy.id, ProductResultTaxonomy.id],
  resultTypeOrderingPerTaxonomy: _defineProperty(_defineProperty({}, CategoriesResultTaxonomy.id, ['categories']), ProductResultTaxonomy.id, ['products']),
  taxonomyFallback: _defineProperty({}, ProductResultTaxonomy.id, ProductResultBertTaxonomy.id),
  includeTaxonomies: [CategoriesResultTaxonomy.id, ProductResultTaxonomy.id],
  taxonomyConfiguration: _defineProperty(_defineProperty({}, CategoriesResultTaxonomy.id, [{
    resultTypeId: 'categories',
    maxResultsByResultType: 8
  }]), ProductResultTaxonomy.id, [{
    resultTypeId: 'products',
    maxResultsByResultType: 8
  }]),
  fillToMaxResults: true
};
function displayConfigurationDecider(applicationName) {
  if (applicationName === HELP_CENTER_APPLICATION_NAME) {
    return helpCenterSearchBarDisplayConfiguration;
  }
  return searchBarDisplayConfiguration;
}

export { displayConfigurationDecider, helpCenterSearchBarDisplayConfiguration, searchBarDisplayConfiguration };
//# sourceMappingURL=searchBarDisplayConfigurations.js.map
